import { render, staticRenderFns } from "./salesStatistics.vue?vue&type=template&id=682865e6&"
import script from "./salesStatistics.vue?vue&type=script&lang=js&"
export * from "./salesStatistics.vue?vue&type=script&lang=js&"
import style0 from "./salesStatistics.vue?vue&type=style&index=0&id=682865e6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports